// extracted by mini-css-extract-plugin
export default {"input":"EditClassworkPerformanceForm_input__q-i7i","del":"EditClassworkPerformanceForm_del__6vrPT"};